import { useTranslation } from '@thoughtspot/i18n';
import { Divider } from '@thoughtspot/radiant-react/widgets/divider';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import React from 'react';
import { Header, WithQueryHandler } from '../common';
import { NodeInfoGridContainer } from './node-info-table/node-info-table.container';
import { TableInfoGridContainer } from './table-info-grid/table-info-grid.container';
import styles from './table-status-cards.module.scss';
import { RelationalDataCacheCard } from './table-status-cards/relational-data-cache.container';
import { RelationalSearchEngineCard } from './table-status-cards/relational-search-engine.container';
export const TableContainer = () => {
    const { t } = useTranslation();
    const renderContent = () => (React.createElement(Vertical, null,
        React.createElement(Header, { title: t('adminSection.system.tableStatus'), titleSize: "large", isFullWidth: true }),
        React.createElement(Divider, null),
        React.createElement(Horizontal, { className: styles.tableStatusMarginTop },
            React.createElement(RelationalDataCacheCard, null),
            React.createElement(RelationalSearchEngineCard, null)),
        React.createElement(Horizontal, null,
            React.createElement(TableInfoGridContainer, null)),
        React.createElement(Horizontal, null,
            React.createElement(NodeInfoGridContainer, null))));
    return renderContent();
};
export const Table = () => {
    return (React.createElement(WithQueryHandler, null,
        React.createElement(TableContainer, null)));
};
//# sourceMappingURL=table-status.js.map